module.exports = __webpack_public_path__ + "static/media/refresh.df0b430d.svg";